<template>
  <div class="realEstatePanel">
    <div class="mt-2">
      <!-- Header: New Gas -->
      <div class="d-flex">
        <feather-icon icon="SendIcon" size="19"/>
        <h4 class="mb-0 ml-50">
          {{ msg('New Gas') }}
        </h4>
      </div>

      <!-- Form: Gas Info -->
      <b-row class="mt-1">

        <b-col cols="12">
          <b-row>
            <b-col cols="4" align-self="center">
              <b-img :src="gas.imageUri" fluid thumbnail style="max-width: 240px; max-height: 300px"/>
            </b-col>
            <b-col cols="8">
              <b-row>
                <b-col cols="12">
                  <b-form-group :label="msg('Provider')">
                    <b-input v-model="gas.provider"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group :label="msg('Therme type')">
                    <b-input v-model="gas.thermeType"/>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>


        <!-- KW Usage -->
        <b-col cols="6">
          <b-form-group :label="msg('KW Usage')">
            <b-form-input v-model="gas.kwUsage" type="number"/>
          </b-form-group>
        </b-col>
        <!-- partialAmount  -->
        <b-col cols="6">
          <b-form-group :label="msg('Partial amount')">
            <b-form-input v-model="gas.partialAmount" type="number"/>
          </b-form-group>
        </b-col>

        <!-- Counter -->
        <b-col cols="6">
          <b-form-group :label="msg('Brand')">
            <b-form-input v-model="gas.brand"/>
          </b-form-group>
        </b-col>


        <!-- Registered -->
        <b-col cols="6">
          <b-form-group :label="msg('Registered')">
            <b-form-datepicker v-model="gas.registered"/>
          </b-form-group>
        </b-col>

        <!-- Status -->
        <b-col cols="6">
          <b-form-group :label="msg('Status')">
            <v-select
                v-model="gas.status"
                :options="gasStatus"
                class="w-100"
                label="text"
                :reduce="(status) => status.value"
            />
          </b-form-group>
        </b-col>


        <!-- Account -->
        <b-col cols="6">
          <b-form-group :label="msg('Account')">
            <b-form-input v-model="gas.account"/>
          </b-form-group>
        </b-col>

        <!-- Password -->
        <b-col cols="6">
          <b-form-group :label="msg('Password')">
            <b-form-input v-model="gas.password"/>
          </b-form-group>
        </b-col>

        <!-- Link -->
        <b-col cols="6">
          <b-form-group :label="msg('Link')">
            <b-form-input v-model="gas.thermeLink"/>
          </b-form-group>
        </b-col>

        <!-- Phone Support -->
        <b-col cols="6">
          <b-form-group :label="msg('User manual')">
            <b-form-input v-model="gas.userManual"/>
          </b-form-group>
        </b-col>


        <!-- reset -->
        <b-col cols="6">
          <b-form-group :label="msg('Resetting')">
            <b-form-input v-model="gas.reset"/>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group :label="msg('Image Uri')">
            <b-input v-model="gas.imageUri"/>
          </b-form-group>
        </b-col>
        <!-- Branch ID -->
        <b-col cols="12">
          <b-form-group :label="msg('Branch')">
            <v-select
                v-model="gas.buid"
                :options="allBranches"
                class="w-100"
                label="name"
                :reduce="(branch) => branch.id"
                :clearable="false"

            />
          </b-form-group>
        </b-col>


        <b-col cols="12">
          <b-form-group :label="msg('Real estate')">
            <real-estate-picker multiple v-model="gas.propertyIds"/>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Save Button -->
      <div v-if="gas.buid!=null && gas.provider!=null" style="float: right" class="justify-content-center mt-2">
        <b-button variant="outline-primary" class="btn-dialog justify-content-center" @click="createGas">
          {{ msg('Save') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import RealEstatePicker from "@/components/components/picker/realEstatesPicker.vue";
import {msg} from "@babel/core/lib/config/validation/option-assertions";

export default {
  name: 'gasPanel',
  components: {RealEstatePicker},
  data() {
    return {
      loaded: false,
      contractId: null,
      gas: {},
      clientId: null,
      contractList: [],
      //Listeners
      listeners: {
        submit: () => {
        }
      }
    }
  },


  computed: {
    ...mapGetters('data', ['getAllBranches']),

    ...mapGetters('gas', ['allGasStatus']),

    gasStatus() {
      let $this = this;
      return this.allGasStatus.map(status => ({
        value: status.value,
        text: $this.msg(status.text)
      }))
    },
    allBranches() {
      return Object.values(this.getAllBranches)
    },
  },
  created() {
    let $this = this;

    this.$root.$on('crm::submitGas', (this.listeners.submit = () => {
      this.submit()
    }))
  },
  beforeDestroy() {
    this.$root.$off('crm::submitGas', this.listeners.submit)
  },
  methods: {
    msg,
    ...mapActions('gas', ['getAllGass', 'copySuccess', 'addGas']),
    ...mapActions('realEstateContracts', ['getAllByClients']),

    formatDate(date) {
      return date ? this.$moment(date, "YYYY-MM-DD").format("DD.MM.YYYY") : "No date";
    },

    createGas() {
      let $this = this

      this.addGas({gas: this.gas})
          .then(
              (id) => {

                $this.$emit('submitted', {status: true, server: id, id})

              },
              (a) => $this.$emit('submitted', {
                status: false,
                server: a
              })
          )
    },

    validate(field) {
      return this.$v.gas[field] != null && this.$v.gas[field].$error === true
    }
    ,
    submit() {
      return this.createGas()
    },

  },

}
</script>
<style scoped>

.dark-layout #realEstate-description {
  background-color: rgba(255, 255, 255, 0.66);
  color: #000000;
}

.quill-container #realEstate-description {

  min-height: 400px;
}
</style>


